import { render, staticRenderFns } from "./RoleItem.vue?vue&type=template&id=d09dd8f0&"
import script from "./RoleItem.vue?vue&type=script&lang=js&"
export * from "./RoleItem.vue?vue&type=script&lang=js&"
import style0 from "./RoleItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports